import { engageDomain } from './clientDomainPath';

export type IsLoadedWithEngageDomain = () => boolean;
export const isLoadedWithEngageDomain: IsLoadedWithEngageDomain = () => window.location.hostname === engageDomain;
